'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PeopleService = function () {
  function PeopleService($http) {
    'ngInject';

    _classCallCheck(this, PeopleService);

    this.$http = $http;
  }

  _createClass(PeopleService, [{
    key: 'getDefaultQuery',
    value: function getDefaultQuery() {
      return _extends({}, (0, _query.getQuery)(), {
        orderBy: 'LastName',
        direction: 'asc'
      });
    }
  }, {
    key: 'search',
    value: function search(query) {
      return this.$http.get('/odata/PeopleOData', {
        params: _extends({
          $select: 'PeopleId, UserId, FirstName, LastName, Email, Username, LevelOfAccess, IsLocked',
          $top: query.take,
          $skip: query.calculateSkip(),
          $orderby: query.orderBy + ' ' + query.direction
        }, query.filter && { $filter: query.filter.toString() }, {
          $count: true
        })
      });
    }
  }]);

  return PeopleService;
}();

exports.default = PeopleService;


// WEBPACK FOOTER //
// ./services/people.service.js